import { render, staticRenderFns } from "./UploadImageUrl.vue?vue&type=template&id=ecf67b1e&scoped=true"
import script from "./UploadImageUrl.vue?vue&type=script&lang=js"
export * from "./UploadImageUrl.vue?vue&type=script&lang=js"
import style0 from "./UploadImageUrl.vue?vue&type=style&index=0&id=ecf67b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf67b1e",
  null
  
)

export default component.exports